
import * as React from 'react';

import { ResourceBadge } from '@/components/ui/resource-badge';
import { useStoreNavigate } from '@/hooks/use-app-navigate';

interface ShippingRateResourceBadgeProps {
    shippingRateId: string;
    variant?: 'default' | 'secondary' | 'destructive' | 'outline';
    className?: string;
}

/**
 * PaymentResourceBadge component for displaying payment information
 * Inherits from generic ResourceBadge
 */
export function ShippingRateResourceBadge({
    shippingRateId,
    variant = 'secondary',
    className,
}: ShippingRateResourceBadgeProps) {
    const { storeRoutes } = useStoreNavigate();
    // Format display value based on available data
    const displayValue = React.useMemo(() => {
        return `${shippingRateId.substring(0, 8)}...`;
    }, [shippingRateId]);

    return (
        <ResourceBadge
            name="variant"
            value={displayValue}
            appLink={storeRoutes.SHIPPING_EDIT(shippingRateId)}
            variant={variant}
            className={className}
        />
    );
}
